import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Mail, MapPin } from 'lucide-react';

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] font-sans flex flex-col">
      <Header />
      <main className="flex-1 px-4 md:px-24 py-12 w-full max-w-5xl mx-auto flex flex-col items-center">
        <h2 className="text-3xl font-bold text-[#172554] text-gujarati mb-2 text-center">
          સંપર્ક/મદદ (Contact & Help)
        </h2>
        <div className="w-24 h-1 bg-[#F5B800] mb-10 rounded"></div>
        
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Contact Info */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-[#E2E8F0]">
            <h3 className="text-xl font-bold text-[#172554] text-gujarati mb-6">અમારો સંપર્ક કરો</h3>
            
            <div className="flex flex-col gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center shrink-0">
                  <Mail className="w-6 h-6 text-[#172554]" />
                </div>
                <div>
                  <div className="text-sm text-[#64748B] font-bold mb-1 text-gujarati">ઇમેઇલ આઇડી</div>
                  <a href="mailto:kagajbook@gmail.com" className="text-lg font-bold text-[#172554] hover:text-[#F5B800] transition-colors">
                    kagajbook@gmail.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center shrink-0">
                  <MapPin className="w-6 h-6 text-[#172554]" />
                </div>
                <div>
                  <div className="text-sm text-[#64748B] font-bold mb-1 text-gujarati">સરનામું</div>
                  <p className="text-[#172554] text-gujarati leading-relaxed">
                    ગુજરાત, ભારત.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Working Hours / Help */}
          <div className="bg-[#172554] p-8 rounded-xl shadow-sm text-white">
            <h3 className="text-xl font-bold text-white text-gujarati mb-6">કામકાજનો સમય</h3>
            
            <div className="flex flex-col gap-4 text-gujarati">
              <div className="flex justify-between items-center border-b border-white/20 pb-3">
                <span className="font-medium">સોમવાર - શુક્રવાર</span>
                <span>સવારે 10:00 થી સાંજે 6:00</span>
              </div>
              <div className="flex justify-between items-center border-b border-white/20 pb-3">
                <span className="font-medium">શનિવાર</span>
                <span>સવારે 10:00 થી બપોરે 2:00</span>
              </div>
              <div className="flex justify-between items-center pb-3">
                <span className="font-medium">રવિવાર</span>
                <span className="text-red-400 font-bold">રજા (Closed)</span>
              </div>
            </div>
            
            <div className="mt-8 bg-white/10 p-4 rounded-lg">
              <p className="text-sm leading-relaxed text-gujarati text-white/90">
                કોઈપણ પ્રશ્ન અથવા સહાય માટે કૃપા કરીને આપેલ નંબર પર WhatsApp દ્વારા અથવા ઇમેઇલ દ્વારા અમારો સંપર્ક કરો. અમે શક્ય તેટલી વહેલી તકે જવાબ આપીશું.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
